import { render, staticRenderFns } from "./orchestratorReleasesView.vue?vue&type=template&id=2717bd08&scoped=true&"
import script from "./orchestratorReleasesView.vue?vue&type=script&lang=ts&"
export * from "./orchestratorReleasesView.vue?vue&type=script&lang=ts&"
import style0 from "./orchestratorReleasesView.vue?vue&type=style&index=0&id=2717bd08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2717bd08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VDataTable,VProgressCircular})
